import { Unlock } from '@griply/assets';
import Typography from '@mui/material/Typography';
import { useUserHadTrial } from 'features/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Sizes } from 'shared/components/ui/button';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';

import * as Styled from './premium-overlay.style';

export type PremiumOverlayProps = {
  title: string;
  description: string;
  children: React.ReactNode;
};

export const PremiumOverlay: React.FC<PremiumOverlayProps> = ({
  title,
  description,
  children,
}) => {
  const { t } = useTranslation();
  const userHadTrial = useUserHadTrial();
  const openPremiumDialog = useOpenPremiumDialog();

  return (
    <Styled.Container>
      {children}

      <Styled.Overlay>
        <Styled.Dialog>
          <Styled.DialogContent>
            <Typography variant="h4" component="h2">
              {title}
            </Typography>
            <Typography variant="body2">{description}</Typography>
          </Styled.DialogContent>

          <Button
            size={Sizes.Large}
            startIcon={Unlock}
            iconStrokeWidth={2}
            onClick={openPremiumDialog}
          >
            {t(
              userHadTrial
                ? 'general.premium-overlay.upgrade.label'
                : 'general.premium-overlay.trial.label',
            )}
          </Button>
        </Styled.Dialog>
      </Styled.Overlay>
    </Styled.Container>
  );
};
